import { Component, Input } from '@angular/core';

@Component({
    selector: 'se-side-details-note',
    templateUrl: './se-side-details-note.component.html',
    styleUrls: ['./se-side-details-note.component.scss'],
})
export class SeSideDetailsNoteComponent {
    @Input() title: string = 'DiagnosticQuery';
    @Input() description: string = 'Dolore lombare cronico e debolezza agli arti inferiori';
}
